module.exports = __webpack_public_path__ + "static/media/managePlant.aef932eb.svg";